<div class="ds-wrapper">
  @if (defaults.noDigitalServicesConfigured) {
    <div class="ds-no-services-overlay">
      <div class="ds-no-services-message">
        <mat-icon>warning_amber</mat-icon>
        <span>The selected tenant does not have Digital Services configured.</span>
      </div>
    </div>
  }
  <div class="ds-content" [class.blurred]="defaults.noDigitalServicesConfigured">
    @if (defaults.controllertype && defaults.controllertype?.IsUsingErrorCodes) {
      <errorcode [isDigitalServicesView]="true"></errorcode>
    }
    @if (defaults.controllertype && !defaults.controllertype?.IsUsingErrorCodes) {
      <operationmode [isDigitalServicesView]="true"></operationmode>
    }
  </div>
</div>
